export enum LanguageActionTypes {
  CHANGE = "@@Language/CHANGE"
}

export interface LanguageState {
  readonly language: string;
}
